import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';

import VueProgressBar from 'vue-progressbar';
import Swal from 'sweetalert2/dist/sweetalert2';

import {API_URL} from './apiurl.config';
import {APP_TONS} from './constanst.config';
import CryptoJs from 'crypto-js';

export const AppConfig = {
  appConfig() {
    const newVue = new Vue({});
    Vue.use(VueAxios, axios);
    axios.defaults.baseURL = API_URL.index();
    axios.interceptors.request.use(
        (config) => {

          newVue.$Progress.start();

          let token = localStorage.getItem(APP_TONS.TOKEN);

          if (token) {
             let parseToken =  CryptoJs.AES.decrypt(token, APP_TONS.ENCRYPTED_SECRET).toString(CryptoJs.enc.Utf8);
            config.headers.Authorization = `Bearer ${parseToken}`;
          }
          return config;
        },

        (error) => {
          newVue.$Progress.fail();
          return Promise.reject(error);
        },
    );

    axios.interceptors.response.use(
        response => {
          newVue.$Progress.finish();
          return Promise.resolve(response);
        },
        error => {
          newVue.$Progress.fail();
          return Promise.reject(error);
        },
    );
  },

  appSweetAlert2() {
    return window.swal = Swal;
  },

  appProgressBar() {
    Vue.use(VueProgressBar, {
      color: '#45F351',
      failedColor: '#3B3E43',
      thickness: '5px',
      height: '2px',
      transition: {
        speed: '2s',
        opacity: '0.6s',
        termination: 100,
      },
      autoRevert: true,
      location: 'top',
      inverse: false,
    });
  },

  elementFocus() {
    Vue.directive('focus', {
      inserted: function(el) {
        el.focus();
      },
    });
  },
};

export default {AppConfig};
